import {
  Flex,
  Image,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import Lock from "../../images/padlock.png";
import Pagination from "../Pagination";

const CustomerNoticeBoard = (props) => {
  return (
    <>
      <Stack mt="30px">
        <TableContainer>
          <Table variant="simple">
            <Thead bgColor="#FFE4E4" h="35px">
              <Tr>
                <Th color="black" textAlign="center" w="10%" fontSize="2xl">
                  번호
                </Th>
                <Th color="black" textAlign="center" w="60%" fontSize="2xl">
                  제목
                </Th>
                <Th color="black" textAlign="center" w="10%" fontSize="2xl">
                  글쓴이
                </Th>
                <Th color="black" textAlign="center" w="20%" fontSize="2xl">
                  등록일
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {props.postList.map((Form, index) => {
                const startingIndex = props.currentPostPage * 10;
                const currentIndex = startingIndex + index;

                return (
                  <Tr
                    key={Form.id}
                    _hover={{
                      backgroundColor:
                        Form.admin === true ? "#FFFF32" : "#F2F2F2",
                    }}
                    backgroundColor={
                      Form.admin === true ? "#FFFFB2" : "inherit"
                    }
                  >
                    <Td textAlign="center" fontSize="lg">
                      {currentIndex + 1}
                    </Td>
                    <Td textAlign="center" fontSize="lg">
                      <a
                        href={
                          props.type === "announcement"
                            ? `/${props.type}/${props.currentPostPage + 1}-${
                                Form.id
                              }`
                            : `/customer-${props.type}/${
                                props.currentPostPage + 1
                              }-${Form.id}`
                        }
                      >
                        <Flex
                          cursor="pointer"
                          justifyContent="center"
                          _hover={{ color: "red" }}
                        >
                          {Form.title}
                          {Form.secret !== false && (
                            <Image
                              src={Lock}
                              boxSize="10px"
                              ml="2px"
                              mt="2px"
                            />
                          )}
                        </Flex>
                      </a>
                    </Td>
                    <Td textAlign="center" fontSize="lg">
                      {Form.publisher}
                    </Td>
                    <Td textAlign="center" fontSize="lg">
                      {Form.createdAt.substr(0, 10)}
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>
        <Flex justifyContent="space-between" alignItems="center" mt="2%">
          <Flex justifyContent="center" flex="1">
            <Pagination
              changePage={props.changePage}
              pageCount={props.postCount}
              selectedPage={props.currentPostPage}
            />
          </Flex>
        </Flex>
      </Stack>
    </>
  );
};

export default CustomerNoticeBoard;
